import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const transactionFeeService = createApi({
  reducerPath: "transactionFeeService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getTransactionFees: builder.query<any, { partnerId?: number }>({
      query: (params) => ({
        url: `/transaction-fee/${params.partnerId}`,
        method: "GET",
        headers: {
          PageName: "Transaction Fee",
        },
      }),
    }),
    getPSPSelectionForTransactionFee: builder.query<any, any>({
      query: (params) => ({
        url: `/transaction-fee/support/psp-selection/${params.merchantId}`,
        method: "GET",
        params,
        headers: {
          PageName: "Transaction Fee",
        },
      }),
      transformResponse: (rawData: any) => {
        return {
          ...rawData,
          data: rawData.data.filter((item: any) => item !== "All")
        }
      },
    }),
    getTransactionFeeByMerchant: builder.query<any, { merchantId: number }>({
      query: (params) => ({
        url: `/transaction-fee/merchant/${params.merchantId}`,
        method: "GET",
        headers: {
          PageName: "Transaction Fee",
        },
      }),
    }),
    getTransactionFeeById: builder.query<any, { id: number }>({
      query: (params) => ({
        url: `/transaction-fee/detail/${params.id}`,
        method: "GET",
        headers: {
          PageName: "Transaction Fee",
        },
      }),
    }),
    getTransactionFeeByPspCode: builder.query<any, { merchantId: number, pspCode: string }>({
      query: (params) => ({
        url: `transaction-fee/support/merchant/${params.merchantId}/detail-by-psp/${params.pspCode}`,
        method: "GET",
        headers: {
          PageName: "Transaction Fee",
        },
      }),
    }),
    createTransactionFeeSupport: builder.mutation<any, any>({
      query: (params) => ({
        url: `/transaction-fee/support`,
        body: params,
        method: "POST",
        headers: {
          PageName: "Transaction Fee",
        },
      }),
    }),
    createTransactionFeeByPartner: builder.mutation<any, any>({
      query: (params) => ({
        url: `/transaction-fee/partner/${params?.partnerId}`,
        body: params,
        method: "POST",
        headers: {
          PageName: "Transaction Fee",
        },
      }),
    }),
    updateTransactionFeeByPartner: builder.mutation<any, { partnerId: number, id: number }>({
      query: (params) => ({
        url: `/transaction-fee/partner/${params?.partnerId}/detail/${params?.id}`,
        body: params,
        method: "PUT",
        headers: {
          PageName: "Transaction Fee",
        },
      }),
    }),
    deleteTransactionFeeByPartner: builder.mutation<any, { partnerId?: number, id: number }>({
      query: (params) => ({
        url: `/transaction-fee/partner/${params?.partnerId}/detail/${params?.id}`,
        params,
        method: "DELETE",
        headers: {
          PageName: "Transaction Fee",
        },
      }),
    }),
    updateTransactionFeeByMerchant: builder.mutation<any, { merchantId: number, id: number }>({
      query: (params) => ({
        url: `/transaction-fee/merchant/${params?.merchantId}/detail/${params?.id}`,
        body: params,
        method: "PUT",
        headers: {
          PageName: "Transaction Fee",
        },
      }),
    }),
    createTransactionFeeByMerchant: builder.mutation<any, { merchantId: number }>({
      query: (params) => ({
        url: `/transaction-fee/merchant/${params?.merchantId}`,
        body: params,
        method: "POST",
        headers: {
          PageName: "Transaction Fee",
        },
      }),
    }),
    deleteTransactionFeeByMerchant: builder.mutation<any, { merchantId?: number, id: number }>({
      query: (params) => ({
        url: `/transaction-fee/merchant/${params?.merchantId}/detail/${params?.id}`,
        params,
        method: "DELETE",
        headers: {
          PageName: "Transaction Fee",
        },
      }),
    }),
  }),
});

export const {
  useLazyGetTransactionFeesQuery,
  useGetPSPSelectionForTransactionFeeQuery,
  useLazyGetTransactionFeeByMerchantQuery,
  useLazyGetTransactionFeeByIdQuery,
  useLazyGetTransactionFeeByPspCodeQuery,
  useCreateTransactionFeeSupportMutation,
  useCreateTransactionFeeByPartnerMutation,
  useUpdateTransactionFeeByPartnerMutation,
  useDeleteTransactionFeeByPartnerMutation,
  useUpdateTransactionFeeByMerchantMutation,
  useCreateTransactionFeeByMerchantMutation,
  useDeleteTransactionFeeByMerchantMutation,
} = transactionFeeService;
